// extracted by mini-css-extract-plugin
export default {"mainContainer":"PlantGrid_mainContainer__jjG+W","gridContainer":"PlantGrid_gridContainer__HNWck","gridWrapper":"PlantGrid_gridWrapper__IX9Wx"};